<template>
	<div class="buy-vip-main-div">
		<div class="table-div">
			<el-table :data="tableData" border v-loading="rightLoading"
				header-row-class-name="el-table-header-202209231449"
				:span-method="objectSpanMethod">
				<el-table-column prop="parentKey" align="center" :label="$t('vip.function_menu')" width="200">
					<template slot-scope="scope">
						<span style="font-size: 18px">{{ getRightsCnByGroup(scope.row.parentKey) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" :label="$t('vip.function_name')" align="left" width="210" header-align="center">
					<template slot-scope="scope">
						<span style="margin-left: 10px">{{ scope.row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" v-for="(item,index) in membershipMap" :key="index" :label="item.name">
					<template slot="header" slot-scope="scope">
						<div style="margin-bottom:15px;">
							{{ $t(item.name) }}
						</div>
<!--						<div class="color-text-grey-1" style="font-size: 12px;">( 设备数量: 1 )</div>-->
						<div v-if="item.level > 0 ">
							<el-row :gutter="10">
								<el-col v-for="(item,index) in rechargeList.slice(0,3)" :span="8" :key="index">
									<div class="charge-box-div">
										<div>
											<span style="font-size: 15px;font-weight: bold;">{{ item.title }}</span>
											<br/>
											<span style="color: #F56C6C;">{{getSymbolByCurrency(item.currency)}}{{item.amount}} </span><span style="text-decoration: line-through;color: #909399;" v-if="item.amount < item.actualCost"> {{getSymbolByCurrency(item.currency)}}{{ item.actualCost }}</span>
											<br/>
											<!-- <span style="color: #F56C6C;">
												{{ item.subhead }}
											</span> -->
										</div>
										<el-button type="primary" size="mini" style="width: 100%"
											@click="rechargeClick(item.level,item.id)">{{$t('vip.buy.name')}}</el-button>
									</div>
								</el-col>
							</el-row>
						</div>
						<div v-else>
							<el-button size="mini" style="min-width: 76px" type="primary"
								@click="rechargeClick(item.level)" round :disabled="!loginUser.isLogin">
								{{ $t('vip.credit.recharge') }}
							</el-button>
						</div>
					</template>
					<template slot-scope="scope">
						{{ void (rights = scope.row.list.find(i => i.level === item.level)) }}
						<div v-html="rights.remark"></div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- <div class="contact-div">
			<div>扫码添加客服经理微信</div>
			<el-image style="width: 200px;height: 200px" :src="imgMaps['cv-qr-code']"></el-image>
		</div> -->
		<buy-vip-dialog-sub v-if="buyVipDialog.visible" :visible="buyVipDialog.visible" @change="(val) => buyVipDialog.visible = val"
			:chargeId="buyVipDialog.chargeId"></buy-vip-dialog-sub>
	</div>
</template>

<script>
import { api_allRights } from "@/components/api/vip";
import { groupArr } from "@/components/common/utils/util";
import { changeDecimal } from "@/components/common/utils/fomatNum";
import { getRightsByGroup, getRightsCnByGroup } from "@/components/config/rightsGroupMap";
import BUY_VIP_DIALOG from '@/components/template/view/userInfo/vip/sub/buyVipDialogSub';
import { api_list_charge } from "@/components/api/charge";
import IMG_MAP from "@/components/config/staticImgMap";

export default {
	name: "buyVip",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER', 'F_LOGIN'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			imgMaps : IMG_MAP,
			rightLoading: false,
			tableData: [],
			buyVipDialog : {
				visible : false,
				chargeId : null,
			},
			rechargeList : []
		}
	},
	components: {
		'buy-vip-dialog-sub' : BUY_VIP_DIALOG
	},
	created() {
		this.loadAllRights(this)
		this.loadChargeData(this)
	},
	computed: {
		currencies() { 
			return [
				{	value : 'CNY' , code : '￥' , name : this.$t('vip.currency.CNY')	} ,
				{	value : 'USD' , code : '$' , name : this.$t('vip.currency.USD')	},
			]
		},
		currency() {
			return this.$store.getters.currency;
		},
		membershipMap() {
			return [
				{ level: 0, key: 'normal', name: this.$t('vip.membership.normal') },
				{ level: 1, key: 'platinum', name: this.$t('vip.membership.platinum')},
			]
		}
	},
	methods: {
		rechargeClick: function(level,chargeId) {
			if (level <= 0) {
				this.$router.push("/recharge")
			} else {
				this.$data.buyVipDialog.visible = true
				this.$data.buyVipDialog.chargeId = chargeId
			}
		},
		loadChargeData: function(this_) {
			this_ = this_ || this
			// 开启遮罩
			this_.F_windowLoading(true)
			api_list_charge(2, this.$store.state.app.currency).then(res => {
				this_.$data.rechargeList = res.data.list
				// 关闭遮罩
				this_.F_windowLoading(false, null)
			}).catch(err => {
				this_.F_alertMsg(this_.F_getErrMSg(err, '充值列表加载错误，请刷新重试'), 4)
				// 关闭遮罩
				this_.F_windowLoading(false, null)
			})
		},
		loadAllRights: function(this_) {
			this_ = this_ || this
			this_.$data.tightLoading = true
			api_allRights().then(res => {
				res.data = res.data.filter(i => i.status !== null && i.status !== 0)
				let data = groupArr(res.data, "functionKey")
				data.map(i => {
					i.list.forEach(item => {
						i.name = item.name
						i.parentKey = item.parentKey
						i.childWeight = item.weight
						delete item.name
					})
					i.weight = getRightsByGroup(i.parentKey).weight
					return i
				})
				data.sort((a, b) => a.weight === b.weight ? a.childWeight - b.childWeight : a.weight - b.weight)
				// data.sort(function(a,b){return a.parentKey.localeCompare(b.parentKey)})
				this_.$data.tableData = data
				this_.$data.tightLoading = false
			}).catch(err => {
				console.error(err)
				this_.$data.tightLoading = false
			})
		},
		objectSpanMethod: function({ row, column, rowIndex, columnIndex }) {
			let this_ = this
			if (columnIndex === 0) {
				let table = this_.$data.tableData;
				let filter = table.filter(i => i.parentKey === row.parentKey)
				if (filter.length > 1) {
					if (filter[0].list[0].id !== row.list[0].id) {
						return {
							rowspan: 0,
							colspan: 0,
						};
					} else {
						return {
							rowspan: filter.length,
							colspan: 1,
						};
					}
				} else {
					return {
						rowspan: 1,
						colspan: 1,
					};
				}
			}
		},
		changeDecimal: function(n) {
			return changeDecimal(n)
		},
		getSymbolByCurrency : function(currency) {
			return this.currencies.find(i => i.value === currency).code
		},
		getRightsCnByGroup: function(key) {
			return getRightsCnByGroup(key)
		},
	},
	watch: {
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		},
		currency: {
			handler() {
				this.loadAllRights(this)
				this.loadChargeData(this)
			},
			deep: true
		}
	},
};
</script>

<style scoped>
.buy-vip-main-div {
	padding: 20px 20px;
	width: 1300px;
	margin: auto;
}
.table-div {
	margin-bottom: 20px;
	min-height: 245px;
}
.charge-box-div{
	font-size: 12px;
	border-radius: 8px;
	border: 1px solid #DCDFE6;
	text-align: center;
	overflow: hidden;
	line-height: 25px;
	padding-top: 10px;
}
.contact-div{
	text-align: center;
}
</style>
<style>
.el-table-header-202209231449 {
	font-size: 24px;
	color: black;
	height: auto !important;
}

</style>